import { createContext, useState, useEffect } from "react";
import axios from "axios";

export const AuthContext = createContext();

const API_URL = process.env.REACT_APP_API_URL 
  || "https://igembe-south-digital-bursary-system.onrender.com";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    setLoading(false);
  }, []);

  const login = async (params) => {
    let url = "";
    let data = {};

    if (params.type === "STUDENT") {
      const identifier = `${params.birthCertificateNo}_${params.admissionNo}`;

      url = `${API_URL}/api/auth/login`;
      data = { identifier, password: params.password };

    } else if (params.type === "ADMIN") {

      url = `${API_URL}/api/auth/admin-login`;
      data = { username: params.username, password: params.password };

    } else {
      throw new Error("Invalid login type");
    }

    const res = await axios.post(url, data);

    setUser(res.data);
    localStorage.setItem("user", JSON.stringify(res.data));

    return res.data;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  if (loading) return null;

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};